import { render } from "./B2bTableRemadv.vue?vue&type=template&id=4fd6327a&scoped=true&lang=pug"
import script from "./B2bTableRemadv.vue?vue&type=script&lang=js"
export * from "./B2bTableRemadv.vue?vue&type=script&lang=js"

import "./B2bTableRemadv.vue?vue&type=style&index=0&id=4fd6327a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd6327a"]])

export default __exports__